// Capacitor rejects a missing native method with ExceptionCode.UNIMPLEMENTED,
// and the web/no-op path with the same code. Anything else is a real failure
// inside a method that DOES exist, and callers must not mistake it for
// "this build has no such method".
export function isUnimplemented(error: unknown): boolean {
  if (typeof error !== "object" || error === null) {
    return false;
  }

  if ((error as { code?: unknown }).code === "UNIMPLEMENTED") {
    return true;
  }

  const message = (error as { message?: unknown }).message;

  return typeof message === "string" && message.includes("not implemented");
}
